let t = 0;
const u = {
  methods: {
    uuid(e) {
      return t++, `${e}-${t}`;
    }
  }
}, n = u;
export {
  n as default
};
